import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.875 19.7475H3.125C1.40188 19.7475 0 18.3456 0 16.6225C0 16.0878 0.137578 15.5599 0.397969 15.0956L7.27129 2.5986C7.2725 2.59642 7.27371 2.59427 7.27492 2.59208C8.46871 0.469697 11.5308 0.468916 12.7251 2.59208C12.7263 2.59423 12.7275 2.59642 12.7287 2.5986L19.6021 15.0956C19.8624 15.5599 20 16.0877 20 16.6225C20 18.3456 18.5981 19.7475 16.875 19.7475ZM8.63844 3.35517L1.76539 15.8516C1.76418 15.8538 1.76297 15.856 1.76176 15.8581C1.63141 16.0899 1.5625 16.3542 1.5625 16.6225C1.5625 17.4841 2.26344 18.185 3.125 18.185H16.875C17.7366 18.185 18.4375 17.4841 18.4375 16.6225C18.4375 16.3542 18.3686 16.0899 18.2382 15.8581C18.237 15.856 18.2358 15.8538 18.2346 15.8516L11.3617 3.35536C10.7636 2.29724 9.23719 2.29603 8.63844 3.35517Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 12.7162C9.56852 12.7162 9.21875 12.3665 9.21875 11.935V7.2475C9.21875 6.81601 9.56852 6.46625 10 6.46625C10.4315 6.46625 10.7812 6.81601 10.7812 7.2475V11.935C10.7812 12.3665 10.4315 12.7162 10 12.7162Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 15.8412C10.4315 15.8412 10.7812 15.4915 10.7812 15.06C10.7812 14.6285 10.4315 14.2787 10 14.2787C9.56853 14.2787 9.21875 14.6285 9.21875 15.06C9.21875 15.4915 9.56853 15.8412 10 15.8412Z",
			fill: "currentColor"
		})
	]
});
export default SvgWarning;
